import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { storage, authFB } from '../../../helpers/Firebase';
import { servicePath, storagePath } from '../../../constants/defaultValues';
import { NotificationManager } from '../../../components/common/react-notifications';
import moment from 'moment';
import { 
  ANSWER_LIST,
  ANSWER_SEARCH_ASSESSMENT_LIST,
  ANSWER_ADD,
  ANSWER_DETAIL,
  ANSWER_UPDATE,
  ANSWER_UPLOAD_SET
} from '../../actions';
import {
  AnswerListSuccess,
  AnswerListError,
  AnswerSearchAssessmentListSuccess,
  AnswerSearchAssessmentListError,
  AnswerAddSuccess,
  AnswerAddError,
  AnswerDetailSuccess,
  AnswerDetailError,
  AnswerUpdateSuccess,
  AnswerUpdateError,
  AnswerUploadSetSuccess,
  AnswerUploadSetError
} from '../../actions';
 
export function* watchAnswerList() {
  yield takeEvery(ANSWER_LIST, onAnswerList);
}

export function* watchAnswerSearchAssessmentList() {
  yield takeEvery(ANSWER_SEARCH_ASSESSMENT_LIST, onAnswerSearchAssessmentList);
}

export function* watchAnswerAdd() {
  yield takeEvery(ANSWER_ADD, onAnswerAdd);
}

export function* watchAnswerDetail() {
  yield takeEvery(ANSWER_DETAIL, onAnswerDetail);
}

export function* watchAnswerUpdate() {
  yield takeEvery(ANSWER_UPDATE, onAnswerUpdate);
}

export function* watchAnswerUpload() {
  yield takeEvery(ANSWER_UPLOAD_SET, onAnswerUpload);
}

const onAnswerListAsync  = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'answer/list', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

const onAnswerUpdateAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'answer/update', {
      method: 'POST', mode: 'cors', cache: 'no-cache',
      headers: { 'Content-Type': 'application/json', 'token': token },
      body: JSON.stringify(data)
  })
      .then(response => response.json())
      .then(data => { return data; })
      .catch(err => console.log(err));
  return { message: true, data: response };
};

function getToken(auth) {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      user.getIdToken().then((token) => {
        unsubscribe();
        resolve(token);
      });
    }, reject);
  });
}

const onAnswerSearchAssessmentListAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/assessment/assessment', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onAnswerAddAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'answer/add', {
      method: 'POST', mode: 'cors', cache: 'no-cache',
      headers: { 'Content-Type': 'application/json', 'token': token },
      body: JSON.stringify(data.payload)
  })
      .then(response => response.json())
      .then(data => { return data; })
      .catch(err => console.log(err));
  return { message: true, data: response };
};

const onAnswerDetailAsync  = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'answer/detail', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

const onAnswerUploadAsync = async (file) => {
  var user = await authFB.currentUser;
  var storageRef = storage.ref()
  let now = moment();
  let filename = `${now.format("x")}.${file.name.substr(file.name.lastIndexOf('.') + 1)}`;
  return await new Promise((success, reject) => {
    var uploadTask = storageRef.child(storagePath+'/answer/' + filename).put(file);
    uploadTask.on('state_changed',
    function(snapshot) {
      var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
      console.log('Upload is ' + progress + '% done');
    }, 
    function(error) {
      reject({ name: filename, original: file.name, message: error.code, url: '',  type: file.type, size: file.size, extension: file.name.substr(file.name.lastIndexOf('.') + 1), path: user.uid+'/consult_documents/' })
    }, 
    function() {
      uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) { 
          success({ message: 'success', name: filename, original: file.name, url: downloadURL, type: file.type, size: file.size, extension: file.name.substr(file.name.lastIndexOf('.') + 1), path: user.uid +'/consult_documents/'});
      });
    });
  });
};


function* onAnswerList(data) {
  try {
    const response = yield call(onAnswerListAsync, data.payload);
    yield put(AnswerListSuccess(response.data));
  } catch (error) {
    yield put(AnswerListError(error));
  }
}

function* onAnswerSearchAssessmentList(data) {
  try {
    const response = yield call(onAnswerSearchAssessmentListAsync, data.payload);
    yield put(AnswerSearchAssessmentListSuccess(response.data));
  } catch (error) {
    yield put(AnswerSearchAssessmentListError(error));
  }
}

function* onAnswerAdd(data) {
  try {
      const response = yield call(onAnswerAddAsync, data);
      console.log(response)
      if (response.data.status === true) {
          NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
      } else if (response.data.status === 'error') {
          NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
      }
      yield put(AnswerAddSuccess(response.data));
  } catch (error) {
      yield put(AnswerAddError(error));
      NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
  }
}

function* onAnswerDetail(data) {
  try {
    const response = yield call(onAnswerDetailAsync, data.payload);
    yield put(AnswerDetailSuccess(response.data.data));
  } catch (error) {
    yield put(AnswerDetailError(error));
  }
}

function* onAnswerUpdate(data) {
  try {
      const response = yield call(onAnswerUpdateAsync, data.payload);
      if (response.data.status === true) {
          NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
      } else if (response.data.status === 'error') {
          NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
      }
      yield put(AnswerUpdateSuccess(response.data));
  } catch (error) {
      yield put(AnswerUpdateError(error));
  }
}

function* onAnswerUpload({ payload }) {
  const { file } = payload;
  try {
    const response = yield call(onAnswerUploadAsync, file);
    if(response.message ==='success'){
      yield put(AnswerUploadSetSuccess(response));
    }
    else{
      yield put(AnswerUploadSetError(response));
    }
  } catch (error) {
    yield put(AnswerUploadSetError({ name: '', original: file.name, message: error, url: '',  type: file.type, size: file.size, extension: file.name.substr(file.name.lastIndexOf('.') + 1), path:''}))
  }
}

export default function* rootSaga() {
  yield all([
    fork(watchAnswerList),
    fork(watchAnswerSearchAssessmentList),
    fork(watchAnswerAdd),
    fork(watchAnswerDetail),
    fork(watchAnswerUpdate),
    fork(watchAnswerUpload),
  ]);
} 